import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// Switch to the new minimal landing app
import App from "./landing/App.jsx";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
